import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Tab, Nav, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadFirmenteilnehmer } from '../../store/actions/fpt';
import { shuffle } from '../../helper/arrayHelper';
import RbsLogoSlider from '../controls/RbsLogoSlider';
import { settings } from '../../config/settings';
import { LinkContainer } from 'react-router-bootstrap';

const countCols = {
  xs: 1,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
  xxl: 4
}

const Firmenteilnehmer = () => {

  const dispatch = useDispatch();
  const storeFpt = useSelector(state => state.fpt);
  const sliderRef = React.useRef();

  const [selectedFpt, setSelectedFpt] = useState('fpt');

  useEffect(() => {
    selectedFpt && dispatch(loadFirmenteilnehmer(selectedFpt));
  }, [dispatch, selectedFpt]);


  const onTabChange = (key) => {
    setSelectedFpt(key);
    console.log('Selected Fpt:', key, storeFpt);
  }


  return (
    <React.Fragment>
      <Container>
        <Tab.Container onSelect={onTabChange} activeKey={selectedFpt}>

          <Row>
            <Col className='text-center'>
              <h1 className="pt-2 pb-0 mb-2">Wer nimmt teil?</h1>
              <p>
                Die Fachpressetage richten sich an Unternehmen aus der Automatisierungsbranche. Beispielsweise
                Hersteller von Automatisierungs- und Steuerungstechnik, Anbieter von Sensorik, Robotik,
                industrieller Software ...
                Eine <LinkContainer to={{ hash: "Themen" }}><a href="#Themen">Themenliste finden Sie hier.</a></LinkContainer>
              </p>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col className='text-center'>
              <Nav variant="pills" className='d-none d-lg-block RbsNavPills '>
                Teilnehmer:&nbsp;                
                <Nav.Item>
                  <Nav.Link eventKey="fpt035">2024</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fpt036">2025</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fpt037">2026</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fpt038">2027</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fpt">Alle</Nav.Link>
                </Nav.Item>
              </Nav>
              <Dropdown onSelect={onTabChange} className='d-lg-none RbsDropdown'>
                <Dropdown.Toggle className='btn-rbs-button-orange-inverse'>
                  {settings.fpt[selectedFpt].year ? settings.fpt[selectedFpt].year : 'Alle'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="fpt035">2024</Dropdown.Item>
                  <Dropdown.Item eventKey="fpt036">2025</Dropdown.Item>
                  <Dropdown.Item eventKey="fpt037">2026</Dropdown.Item>
                  <Dropdown.Item eventKey="fpt038">2027</Dropdown.Item>
                  <Dropdown.Item eventKey="fpt">Alle</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          <Row className='mt-5'>
            <Col>
              <RbsLogoSlider
                ref={sliderRef}
                countCols={countCols}
                logos={storeFpt && selectedFpt && storeFpt[selectedFpt].firmen &&
                  shuffle(storeFpt[selectedFpt].firmen
                    .filter(f => selectedFpt !== 'fpt' || f.logoFile)
                    .map(f => ({
                      url: f.logoFile && settings.network.logoUrl + f.logoFile,
                      description: f.firmenname
                    }))
                  )
                }
                speed={2000}
                hideDots={selectedFpt === 'fpt'}
              />
            </Col>
          </Row>

        </Tab.Container>
      </Container>
    </React.Fragment>
  );
}

export default Firmenteilnehmer;